
export function setRoles(roles: number[]): number {
  return roles.reduce((reduce, current) => reduce | Math.pow(2, current), 0);
}

export function allowRole(allows, role): boolean {
  return (allows & Math.pow(2, role)) !== 0;
}

export const ROLES = {
  APODERADO: 1,
  ALUMNO: 2,
  PROFESOR: 3,
  VENDEDOR: 4,
  COORDINADOR: 5,
  ADMINISTRADOR: 6,
  COORDINADORGENERAL: 7,
  RECEPCIONISTA: 8,
  DIRECTOR: 9,
  INSTITUTO: 10,
  AUDITOR: 12,
  JEFECONTABILIDAD: 13,
  JEFEVENTAS: 14,
  IMPRESIONES: 15,
  COORDINADORDESEDE: 16,
  GESTORACADEMICO: 17,
  AFILIADO: 18,
  IMPRESIONESSEDE: 19,
}

export function getRoleName(roleId: number | null | undefined): string {
  switch (roleId) {
    case 1: return 'Apoderado';
    case 2: return 'Alumno';
    case 3: return 'Profesor';
    case 4: return 'Vendedor';
    case 5: return 'Coordinador';
    case 6: return 'Administrador';
    case 7: return 'Coordinador General';
    case 8: return 'Recepcionista';
    case 9: return 'Director';
    case 10: return 'Instituto';
    case 18: return 'Embajador';
    case 15:
    case 19: return 'Impresiones';
    default: return '';
  }
}

/** Mapa global de roles secundarios permitidos para cada rol principal */
export const ALLOWED_SECONDARY_ROLES: { [primaryRoleId: number]: number[] } = {
  [ROLES.APODERADO]: [ROLES.AFILIADO],
  [ROLES.ALUMNO]: [ROLES.AFILIADO],
  [ROLES.RECEPCIONISTA]: [ROLES.IMPRESIONESSEDE],
  [ROLES.PROFESOR]: [ROLES.AFILIADO],
};

/** Helper para obtener las opciones de perfil secundario asignables a un rol primario */
export function getSecondaryRoleOptions(primaryRoleId: number | null | undefined): { id: number; name: string }[] {
  if (!primaryRoleId) return [];
  const allowedIds = ALLOWED_SECONDARY_ROLES[primaryRoleId] || [];
  return allowedIds.map(id => ({ id, name: getRoleName(id) }));
}

/** Roles cuyo formulario siempre ofrece el selector de Sede. */
export const CAMPUS_ROLES: number[] = [ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.IMPRESIONES];

/** Roles que solo ofrecen el selector de Sede cuando se marcan como coordinador. */
export const COORDINATOR_CAMPUS_ROLES: number[] = [ROLES.PROFESOR, ROLES.VENDEDOR];

/** Roles secundarios cuyo alcance es por sede: al asignarlos la Sede deja de ser opcional. */
export const CAMPUS_REQUIRED_SECONDARY_ROLES: number[] = [ROLES.IMPRESIONESSEDE];

/** True si el perfil secundario asignado obliga a seleccionar Sede. */
export function secondaryRoleRequiresCampus(secondaryRoleId: number | null | undefined): boolean {
  return !!secondaryRoleId && CAMPUS_REQUIRED_SECONDARY_ROLES.includes(secondaryRoleId);
}
